const isKidsMode = () => localStorage.getItem("kids_mode") === "1";

const isAllowed = (item) => {
    const age = parseInt(item?.age_restrict) || 0;
    return age === 0 || age <= 10;
};

export const filterKidsContent = (items) => {
    if (!Array.isArray(items) || !isKidsMode()) return items;
    return items.filter(isAllowed);
};

// Filters every array-valued key in an object (for watchlater/wishlist payloads)
export const filterKidsObjectArrays = (obj) => {
    if (!obj || !isKidsMode()) return obj;
    const result = { ...obj };
    Object.keys(result).forEach(key => {
        if (Array.isArray(result[key])) {
            result[key] = result[key].filter(isAllowed);
        }
    });
    return result;
};
